import defaultState from './state';

const SAVE_SELECTED_INVOICE_DATA_INDEX = (state, index) => {
  state.selectedInvoiceDataIndex = index;
};

export default {
  SAVE_SELECTED_INVOICE_DATA_INDEX,
};
